import { render, staticRenderFns } from "./RawModel.vue?vue&type=template&id=20c9a3af&scoped=true"
import script from "./RawModel.vue?vue&type=script&lang=js"
export * from "./RawModel.vue?vue&type=script&lang=js"
import style0 from "./RawModel.vue?vue&type=style&index=0&id=20c9a3af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9a3af",
  null
  
)

export default component.exports